export { default as whitearrow } from "./images/general/white-arrow.svg";
export { default as circle } from "./images/general/circle.svg";
export { default as wctaarrow } from "./images/general/Polygon-3.svg";
export { default as downarrow } from "./images/general/Polygon-1.svg";
export { default as downarrowcircle } from "./images/general/down-arrow.svg";
export { default as redarrow } from "./images/general/red-arrow.svg";
export { default as blackarrow } from "./images/general/black-arrow.svg";
export { default as greyarrow } from "./images/general/grey-arrow.svg";
export { default as rightcirclearrow } from "./images/general/right-arrow.svg";
export { default as leftcirclearrow } from "./images/general/left-arrow.svg";
export { default as pinkpatch } from "./images/general/count_icon_patch.svg";
export { default as instaicon } from "./images/general/insta-icon.svg";
export { default as fbicon } from "./images/general/fb-icon.svg";
export { default as scrollup } from "./images/general/scroll-icon.svg";
export { default as plusicon } from "./images/general/plus-icon.svg";
export { default as minusicon } from "./images/general/minus-icon.svg";
export { default as rightcirclewhite } from "./images/general/right-circle-arrow.svg";
export { default as mailicon } from "./images/general/mail-icon.svg";
export { default as phonecallicon } from "./images/general/phone-call-icon.svg";
export { default as searchicon } from "./images/general/search-icon.svg";
export { default as everestlogo } from "./images/general/everest-logo.png";
export { default as everestlogoHeader } from "./images/general/everest_logo.png";
export { default as darklogofallback } from "./images/general/dark-logo.png";
export { default as lightlogo } from "./images/general/light-logo.webp";
export { default as lightlogofallback } from "./images/general/light-logo.png";
export { default as fbwhite } from "./images/general/fb-white.svg";
export { default as fbgrey } from "./images/general/fb-grey.svg";
export { default as instawhite } from "./images/general/insta-white.svg";
export { default as instagrey } from "./images/general/insta-grey.svg";
export { default as ytwhite } from "./images/general/yt-white.svg";
export { default as yticon } from "./images/general/yt-icon.svg";
export { default as linkedinwhite } from "./images/general/linkedin-white.svg";
export { default as linkedingrey } from "./images/general/linkedin-grey.svg";
export { default as footerlocation } from "./images/general/footer-location-icon.svg";
export { default as footermail } from "./images/general/footer-mail-icon.svg";
export { default as footercall } from "./images/general/footer-phone-call-icon.svg";
export { default as activearrow } from "./images/general/hamburger-arrow.svg";
export { default as downarrowred } from "./images/general/down-arrow2.svg";
export { default as coloredlist } from "./images/general/colored-list.svg";
export { default as emailicon } from "./images/general/email-icon.svg";
export { default as callicon } from "./images/general/call-icon.svg";
export { default as closeIcon } from "./images/general/close-icon.svg";
export { default as closeIconRed } from "./images/general/close-icon-red.svg";
export { default as facebookIcon } from "./images/general/facebook.svg";
export { default as youtubeIcon } from "./images/general/youtube.svg";
export { default as instaIcon } from "./images/general/insta.svg";
export { default as instaIconHover } from "./images/general/insta-hover.svg";
export { default as playIcon } from "./images/general/play_icon.svg";
export { default as leftArrow } from "./images/general/Left_Arrow.svg";
export { default as rightArrow } from "./images/general/Right_Arrow.svg";

//HOME IMAGES
export { default as tickIcon } from "./images/home/tick-icon.svg";
export { default as earlyaccess } from "./images/home/early-access.svg";
export { default as vouchersprizes } from "./images/home/vouchers-prizes.svg";
export { default as exclusivecollab } from "./images/home/exclusive-collab.svg";
export { default as brandfeatures } from "./images/home/brand-features.svg";
export { default as videoBg } from "./images/home/video_bg.jpg";
export { default as videoBgMobile } from "./images/home/mb_video_bg.jpg";
export { default as formImg } from "./images/home/form_img.png";
export { default as formImgMb } from "./images/home/form_img_mb.jpeg";

//THANK YOU IMAGES
export { default as thankSpices } from "./images/thank-you/hot_spices.png";
export { default as registerWarning } from "./images/thank-you/warning.svg";

// WINNERS IMAGES
export { default as winnerBanner } from "./images/winners/winner_banner_1.jpg";
export { default as winnerBannerMb } from "./images/winners/winner_banner_mb_1.jpg";
export { default as winnerLeftElement } from "./images/winners/left_element.png";
export { default as winnerRightElement } from "./images/winners/right_element.png";

export let images = {
  homeBanner01: {
    img: require("./images/home/home-banner-9.jpg"),
  },
  homeBannerMb01: {
    img: require("./images/home/home-banner-mb-9.jpg"),
  },
  homeBanner02: {
    img: require("./images/home/home-banner-6.jpg"),
  },
  // homeBanner02_1: {
  //   img: require("./images/home/home-banner-3.jpg"),
  // },
  homeBannerMb02: {
    img: require("./images/home/home-banner-mb-6.png"),
  },
  homeBanner03: {
    img: require("./images/home/home-banner-10.jpg"),
  },
  homeBannerMb03: {
    img: require("./images/home/home-banner-mb-10.png"),
  },
  homeBanner04: {
    img: require("./images/home/home-banner-11.png"),
  },
  homeBannerMb04: {
    img: require("./images/home/home-banner-mb-11.png"),
  },
  aboutImg: {
    img: require("./images/home/about-img.jpg"),
  },
  aboutFloat: {
    img: require("./images/home/about-float.png"),
  },
  programFloat: {
    img: require("./images/home/program-float.png"),
  },
  gratificationbanner: {
    img: require("./images/home/gratification-banner-1.jpeg"),
  },
  gratificationbannerMb: {
    img: require("./images/home/gratification-banner-mb-1.jpeg"),
  },
  registrationprocess: {
    img: require("./images/home/registration-process-2.png"),
  },
  registrationprocessmb: {
    img: require("./images/home/registration-process-mb-2.png"),
  },
};
